export default defineNuxtRouteMiddleware((to, from) => {
  if (!from.name) {
    const id = to.params.id as string
    return navigateTo(id === 'bulk' ? '/policies' : `/policies/${id}`, {
      replace: true,
    })
  }
})
